// import GoogleMapBusRoute from './GoogleMapBusRoute'

import BusMap from './BusMap'

const LiveBusRouteMap = ({busLiveLocation, schoolLocation, lookAtBus, setLookAtBus}) => {
  return (
    <div style={{height: '100%', width: '100%'}}>
      <BusMap
        center={{
          lng: busLiveLocation.features[0].geometry.coordinates[0],
          lat: busLiveLocation.features[0].geometry.coordinates[1],
        }}
        lookAtBus={lookAtBus}
        setLookAtBus={setLookAtBus}
        busGeoJson={busLiveLocation}
        schoolLocation={schoolLocation}
      />
    </div>
  )
}

export default LiveBusRouteMap
